import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import App from './App'
import reportWebVitals from './reportWebVitals'
import { msalConfig } from 'components/sso/authConfig'
import { MsalProvider } from '@azure/msal-react'
import { EventType, PublicClientApplication } from '@azure/msal-browser'

export const msalInstance = new PublicClientApplication(msalConfig)

const root = ReactDOM.createRoot(document.getElementById('root'))

msalInstance.addEventCallback((event) => {
  if (
    (event.eventType === EventType.LOGIN_SUCCESS ||
      event.eventType === EventType.ACQUIRE_TOKEN_SUCCESS) &&
    event.payload &&
    'account' in event.payload
  ) {
    const account = event.payload.account
    msalInstance.setActiveAccount(account)
  }
})

msalInstance
  .handleRedirectPromise()
  .then((result) => {
    if (result?.account) {
      msalInstance.setActiveAccount(result.account)
    } else {
      const accounts = msalInstance.getAllAccounts()
      if (accounts.length > 0) msalInstance.setActiveAccount(accounts[0])    
    }

    root.render(
      <React.StrictMode>
        <MsalProvider instance={msalInstance}>
          <App />
        </MsalProvider>
      </React.StrictMode>,
    )
  })
  .catch((e) => {
    console.error('MSAL redirect error:', e)

    ReactDOM.createRoot(root).render(
      <React.StrictMode>
        <MsalProvider instance={msalInstance}>
          <App />
        </MsalProvider>
      </React.StrictMode>,
    )
  })

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
